/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="12.79" height="19" viewBox="0 0 12.79 19" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path d="M12.79 0v19H0V0Zm-1 1H1v17h10.78Zm-1.31 10.7v4.8H8.82v-4.8Zm-3.29 3.16v1.64H5.52v-1.59Zm-3.26 0v1.64H2.27v-1.59Zm3.26-3.16v1.6H5.52v-1.6Zm-3.26 0v1.6H2.27v-1.6Zm6.55-3.16v1.6H8.82V8.5ZM7.19 8.5v1.6H5.52V8.5Zm-3.26 0v1.6H2.27V8.5Zm6.55-6.27v5.06H2.27V2.24Zm-1 1H3.27v3.05h6.21Z" className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CalculatorIcon';

export default Icon;
